import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { formatCurrency } from '../utils/formatters';
import './PublicQuotation.css';

const PublicQuotation = () => {
    const { token } = useParams();
    const [password, setPassword] = useState('');
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [quotation, setQuotation] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [obsFornecedor, setObsFornecedor] = useState('');
    const [success, setSuccess] = useState(false);
    const [otherQuotations, setOtherQuotations] = useState([]);

    const handleAuth = async (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await fetch(`/api/cotacao-publica/${token}?senha=${password}`);
            if (res.ok) {
                const data = await res.json();
                const formattedData = {
                    ...data,
                    itens: data.itens.map(item => ({
                        ...item,
                        PrecoOfertado: item.PrecoOfertado ? Number(item.PrecoOfertado).toFixed(2) : ''
                    }))
                };
                setQuotation(formattedData);
                setObsFornecedor(data.ObservacaoFornecedor || '');
                setIsAuthorized(true);
                fetchOtherQuotations(data.IDFornecedor);
            } else {
                const data = await res.json();
                setError(data.message || 'Erro ao acessar cotação.');
            }
        } catch (err) {
            setError('Erro de conexão com o servidor.');
        } finally {
            setLoading(false);
        }
    };


    const fetchOtherQuotations = async (supplierId) => {
        try {
            const res = await fetch(`/api/cotacoes-fornecedor-publico/${supplierId}?token=${token}`);
            if (res.ok) {
                const data = await res.json();
                setOtherQuotations(data.filter(q => q.Token !== token));
            }
        } catch (err) {
            console.error('Erro ao buscar outras cotações:', err);
        }
    };
    const handlePriceChange = (id, price) => {
        const newItens = quotation.itens.map(item =>
            item.ID === id ? { ...item, PrecoOfertado: price } : item
        );
        setQuotation({ ...quotation, itens: newItens });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await fetch(`/api/cotacao-publica/${token}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    senha: password,
                    ObservacaoFornecedor: obsFornecedor,
                    itens: quotation.itens
                })
            });
            if (res.ok) {
                setSuccess(true);
            } else {
                setError('Erro ao enviar cotação.');
            }
        } catch (err) {
            setError('Erro ao enviar cotação.');
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="public-quotation-container">
                <div className="win95-window success-box">
                    <div className="win95-title">Cotação Enviada</div>
                    <div className="win95-body">
                        <p>Obrigado! Sua cotação foi enviada com sucesso.</p>
                        <button className="win95-btn" onClick={() => window.location.reload()}>Voltar</button>
                    </div>
                </div>
            </div>
        );
    }

    if (!isAuthorized) {
        return (
            <div className="public-quotation-container">
                <div className="win95-window auth-box">
                    <div className="win95-title">Acesso Restrito - Cotação</div>
                    <form className="win95-body" onSubmit={handleAuth}>
                        <p>Por favor, insira a senha fornecida para acessar esta solicitação de cotação.</p>
                        <div className="form-group">
                            <label>Senha:</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        {error && <p className="error-text">{error}</p>}
                        <button type="submit" className="win95-btn" disabled={loading}>
                            {loading ? 'Acessando...' : 'Acessar Cotação'}
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className="public-quotation-container">
            <div className="quotation-layout">
                <div className="win95-window quotation-box">
                    <div className="win95-title">Preenchimento de Cotação #{quotation.ID}</div>
                    <div className="win95-body">
                        <div className="info-section">
                            <h4>Instruções do Comprador:</h4>
                            <p className="obs-box">{quotation.ObservacaoUsuario || 'Nenhuma observação informada.'}</p>
                        </div>


                        <form onSubmit={handleSubmit}>
                            <table className="quotation-table">
                                <thead>
                                    <tr>
                                        <th>Produto</th>
                                        <th>Qtd</th>
                                        <th>Preço Unitário (R$)</th>
                                        <th>Total (R$)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {quotation.itens.map(item => (
                                        <tr key={item.ID}>
                                            <td>{item.NomeProduto}</td>
                                            <td>{item.Quantidade}</td>
                                            <td>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        value={item.PrecoOfertado || ''}
                                                        onChange={(e) => handlePriceChange(item.ID, e.target.value)}
                                                        placeholder="0,00"
                                                        required
                                                        disabled={false}
                                                        style={{ width: '100px' }}
                                                    />
                                                    <span style={{ fontSize: '0.75rem', color: '#666' }}>
                                                        {item.PrecoOfertado ? formatCurrency(item.PrecoOfertado) : 'R$ 0,00'}
                                                    </span>
                                                </div>
                                            </td>
                                            <td style={{ fontWeight: 'bold' }}>
                                                {formatCurrency((item.PrecoOfertado || 0) * item.Quantidade)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="form-group" style={{ marginTop: '20px' }}>
                                <label>Suas Observações:</label>
                                <textarea
                                    value={obsFornecedor}
                                    onChange={(e) => setObsFornecedor(e.target.value)}
                                    placeholder="Condições de pagamento, prazo de entrega, etc."
                                    disabled={false}
                                />
                            </div>

                            {error && <p className="error-text">{error}</p>}

                            <div className="form-actions">
                                <button type="submit" className="win95-btn primary" disabled={loading}>
                                    {loading ? 'Enviando...' : 'Enviar Cotação'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                {otherQuotations.length > 0 && (
                    <aside className="win95-window other-quotations-box">
                        <div className="win95-title">Outras Cotações</div>
                        <div className="win95-body">
                            <div className="other-list">
                                {otherQuotations.map(q => (
                                    <div key={q.ID} className="other-item-wrapper" style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                        <div className="other-item" onClick={() => window.location.href = `/public-quotation/${q.Token}?senha=${password}`} style={{ flex: 1 }}>
                                            <strong>#{q.ID}</strong>
                                            <span>{new Date(q.DataCotacao).toLocaleDateString('pt-BR')}</span>
                                            <span className={`status-badge ${q.Status.toLowerCase()}`}>{q.Status}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </aside>
                )}
            </div>
        </div>
    );
};

export default PublicQuotation;
